import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { selectUserData } from '../../reducers/userDataReducer'
import './asset-tracking.scss'

const AssetTracking = () => {
  const { t } = useTranslation(['asset-tracking'])
  const userData = useSelector(selectUserData)
  const userEmail = userData?.user?.email || ''

  return (
    <div className="asset-tracking">
      <div className="asset-tracking__container">
        <iframe
          src={`https://elevateoshub.com/embed/assets-inventory?email=${encodeURIComponent(userEmail)}`}
          className="asset-tracking__iframe"
          title={t('asset-tracking:title')}
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </div>
  )
}

export default AssetTracking
